import configData from '../../config.json';
import axios from 'axios';
import { Decrypt } from '../Helper';

export const GetChallengeReport = async (v) => {
    var config = {
        method: 'get',
        url: configData.API_ENDPOINT + `report/groupbychallenge`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetCompanyReport = async (v) => {
    var config = {
        method: 'get',
        url: configData.API_ENDPOINT + `report/groupbycompany`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetCollegeReport = async (v) => {
    var config = {
        method: 'get',
        url: configData.API_ENDPOINT + `report/groupbycollege`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetChallengeParticipants = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `report/challengeparticipate`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetCompanyParticipants = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `report/getcompany`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
